module.exports = __webpack_public_path__ + "img/turner-logo.a53e8534.jpg";